module.exports = {"institutions_list":{"page_title":["Institutions","Institutions"],"title":["<span>Institutions</span> culturelles","<span>Institutions</span> culturelles"],"button_back":["Retour","Back"],"button_filter":["Filtrer","Filter"],"button_load_more":["Charger plus...","Load more..."],"no_item_found":["Il n'y a aucune institutions pour l'instant.","There is no institutions for the moment."]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Institutions/translations/translations_institutions_list.json
// module id = 446
// module chunks = 0